module.exports = "<p>\n  buyers-tier-pie-chart works!\n</p>"